export const formActions = [
  {
    name: 'submitSelectedForm',
    label: 'Submit Form',
    args: [
      {
        name: 'enableSubmitForm',
        label: 'Submit Selected Form',
        type: 'boolean',
        value: '',
      },
      {
        name: 'componentPage',
        label: 'Page',
        type: 'dropdown',
        optionsType: 'showComponentPageApi',
        options: [],
        value: '',
      },
      {
        name: 'formComponent',
        label: 'Form Component',
        type: 'dropdown',
        optionsType: 'pageFormComponents',
        options: [],
        value: '',
      },
      {
        name: 'overrideSubmitWaitTime',
        label: 'Wait Time (Default: 500)',
        type: 'number',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'resetFormFields',
    label: 'Reset Form Fields',
    args: [
      {
        name: 'enableResetForm',
        label: 'Reset Selected Form',
        type: 'boolean',
        value: '',
      },
      {
        name: 'componentPage',
        label: 'Page',
        type: 'dropdown',
        optionsType: 'showComponentPageApi',
        options: [],
        value: '',
      },
      {
        name: 'formComponent',
        label: 'Form Component',
        type: 'dropdown',
        optionsType: 'pageFormComponents',
        options: [],
        value: '',
      },
      {
        name: 'overrideResetWaitTime',
        label: 'Wait Time (Default: 500)',
        type: 'number',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'referenceDropDownOnChange',
    label: 'Set Form Values by Dropdown',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'formPage',
        label: 'Page',
        type: 'dropdown',
        optionsType: 'sourcePageApi',
        options: [],
        value: '',
      },
      {
        name: 'mapping',
        label: 'Mapping',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: '',
      },
    ],
  },
];
